document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector("[data-hero-slider]");
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll(".hero-slide"));
  const prevBtn = document.querySelector("[data-hero-prev]");
  const nextBtn = document.querySelector("[data-hero-next]");
  const dotsWrap = document.querySelector("[data-hero-dots]");

  if (slides.length <= 1) return;

  let index = 0;
  let timer = null;
  let startX = 0;
  let currentX = 0;
  let isSwiping = false;

  const autoplayEnabled = slider.dataset.autoplay === "true";
  const intervalSeconds = parseInt(slider.dataset.interval || "6", 10);
  const intervalMs = Math.max(3000, intervalSeconds * 1000);

  function update() {
    slider.style.transform = `translateX(-${index * 100}%)`;
    updateDots();
  }

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    update();
  }

  function next() {
    goTo(index + 1);
  }

  function prev() {
    goTo(index - 1);
  }

  // Dots
  function buildDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = "";
    slides.forEach((_, i) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "hero-dot";
      b.setAttribute("aria-label", `Go to slide ${i + 1}`);
      b.addEventListener("click", () => {
        stopAutoplay();
        goTo(i);
        startAutoplay();
      });
      dotsWrap.appendChild(b);
    });
    updateDots();
  }

  function updateDots() {
    if (!dotsWrap) return;
    const dots = Array.from(dotsWrap.querySelectorAll(".hero-dot"));
    dots.forEach((d, i) => d.classList.toggle("is-active", i === index));
  }

  // Autoplay
  function startAutoplay() {
    if (!autoplayEnabled) return;
    stopAutoplay();
    timer = window.setInterval(next, intervalMs);
  }

  function stopAutoplay() {
    if (timer) window.clearInterval(timer);
    timer = null;
  }

  // Buttons
  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      stopAutoplay();
      next();
      startAutoplay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      stopAutoplay();
      prev();
      startAutoplay();
    });
  }

  // Pause on hover (desktop)
  slider.addEventListener("mouseenter", stopAutoplay);
  slider.addEventListener("mouseleave", startAutoplay);

  // Basic swipe (mobile)
  slider.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    currentX = startX;
    isSwiping = true;
    stopAutoplay();
  }, { passive: true });

  slider.addEventListener("touchmove", (e) => {
    if (!isSwiping) return;
    currentX = e.touches[0].clientX;
  }, { passive: true });

  slider.addEventListener("touchend", () => {
    if (!isSwiping) return;
    isSwiping = false;

    const diff = currentX - startX;
    const threshold = 40;

    if (diff > threshold) prev();
    else if (diff < -threshold) next();

    startAutoplay();
  });

  // Init
  buildDots();
  update();
  startAutoplay();
});
